export default "__VITE_ASSET__B00RbSPB__"